export { default as FullWidthImage } from "./FullWidthImage";
export { default as HeadlineWithDescription } from "./HeadlineWithDescription";
export { default as InfoWithImage } from "./InfoWithImage";
export { default as TextInfo } from "./TextInfo";
export { default as HeroImage } from "./HeroImage/HeroImage";
